import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'number-3', 'Number3', [["path",{"d":"M12 12a4 4 0 1 0 -4 -4"}],["path",{"d":"M8 16a4 4 0 1 0 4 -4"}]]);